<script setup lang="ts">
  import { IconEmptySection, Text } from "@ui-kit";
</script>

<template>
  <div class="orders-not-found">
    <div class="icon">
      <IconEmptySection style="width: 54px; height: 64px" />
    </div>
    <Text font="heading-H4">{{ $t("Нет доступных запросов") }}</Text>
    <Text>{{ $t("Измените фильтры или дождитесь новых заданий") }}</Text>
  </div>
</template>

<style scoped>
  .orders-not-found {
    display: flex;
    width: 100%;
    height: 100%;
    flex-direction: column;
    align-items: center;
    padding: 110px 16px 0;
    background-color: var(--sf-base-background-primary);
    text-align: center;

    .icon {
      width: fit-content;
      height: fit-content;
      padding: 25px 33px;
      background-color: var(--sf-base-background-white);
      border-radius: 50%;
      margin-bottom: 16px;
    }

    & :deep(.text:first-of-type) {
      margin-bottom: 8px;
    }
  }
</style>
